const Config = {
  set config(config) {
    this.conf = config;
    this.env = process.env.NODE_ENV;
    if (process.env.NODE_ENV === 'production') {
      this.env = 'build';
    }
    const urls = config.API_URL[this.env];
    this.apiUrl = urls.base;
    this.cognitoUrl = urls.cognito;
  },
  set apiUrl(url) {
    this.conf.apiUrl = url;
  },
  get apiUrl() {
    return this.conf.apiUrl;
  },
  set cognitoUrl(url) {
    this.conf.cognitoUrl = url;
  },
  get cognitoUrl() {
    return this.conf.cognitoUrl;
  },
  get APP_CLIENT() {
    return this.conf.APP_CLIENT;
  },
  get version() {
    return this.conf.version;
  },
  get checkUrl() {
    return `${window.location.origin}/src/assets/images/singlePixel.jpeg`;
  },
};

export default Config;
